/**
 * source: https://dev.to/monaye/refactor-davidwalsh-s-debounce-function-5afc
 */
export const throttle = (func, delay, immediate) => {
  let timerId;
  return (...args) => {
    const boundFunc = func.bind(this, ...args);
    if (timerId) {
      return;
    }
    if (immediate && !timerId) {
      boundFunc();
    }
    timerId = setTimeout(() => {
      if (!immediate) {
        boundFunc();
      }
      timerId = null;
    }, delay);
  };
};

/**
 * source: https://dev.to/monaye/refactor-davidwalsh-s-debounce-function-5afc
 */
export const debounce = (func, delay) => {
  let timerId;
  return (...args) => {
    const boundFunc = func.bind(this, ...args);
    clearTimeout(timerId);
    timerId = setTimeout(boundFunc, delay);
  };
};
